import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsParkingRuleType} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'pass-type-modal',
    templateUrl: './pass-type-modal.component.html',
    styleUrls: ['./pass-type-modal.component.scss']
})
export class PassTypeModalComponent implements OnInit {
    @ViewChild('form') form;
    title = '';
    showModal = false;
    data: SettingsParkingRuleType = new SettingsParkingRuleType();
    disabledSubmit = false;
    hoursArray: Array<any> = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    minutesArray: Array<any> = ['00', '30'];
    weekDaysNamesArray: Array<any> = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    step = 'schedule';
    startOnTime = {hours: '', minutes: '', amPM: ''};
    endOnTime = {hours: '', minutes: '', amPM: ''};
    selectPerValues = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];
    selectValues = [
        {name: 'day', displayName: 'Day'},
        {name: 'week', displayName: 'Week'},
        {name: 'month', displayName: 'Month'},
        {name: 'year', displayName: 'Year'}
    ];
    selectedRepeatableDays: Array<any> = [
        {dayNumber: 1, selected: false},
        {dayNumber: 2, selected: false},
        {dayNumber: 3, selected: false},
        {dayNumber: 4, selected: false},
        {dayNumber: 5, selected: false},
        {dayNumber: 6, selected: false},
        {dayNumber: 7, selected: false}
    ];
    showSchedulerSpinner = false;
    schedulerOptions: any;
    isEditMode = false;


    constructor(
        public api: ApiClientService,
        public settingsParkingPassesService: SettingsParkingPassesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.initScheduler();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsParkingPassesService.passTypeInPassTypeModal) {
            this.isEditMode = true;
            this.data = JSON.parse(JSON.stringify(this.settingsParkingPassesService.passTypeInPassTypeModal));
            if(this.settingsParkingPassesService.selectedItemData.type == 'general') {
                if (this.data.passTypeSchedule.startTime)
                    this.startOnTime = this.getScheduleTimeSplitted(this.data.passTypeSchedule.startTime);
                if (this.data.passTypeSchedule.endTime)
                    this.endOnTime = this.getScheduleTimeSplitted(this.data.passTypeSchedule.endTime);
                if (this.data.passTypeSchedule.scheduleDays) {
                    this.selectedRepeatableDays.forEach((scheduleDayInModal) => {
                        this.data.passTypeSchedule.scheduleDays.forEach((scheduleDay) => {
                            if (scheduleDay.dayNumber == scheduleDayInModal.dayNumber)
                                scheduleDayInModal.selected = true;
                        });
                    });
                }
            }
            this.title = this.settingsParkingPassesService.passTypeInPassTypeModal.name;
        }
    }

    initScheduler(): void {
        this.schedulerOptions = {
            editable: false,
            displayEventEnd: true,
            eventLimit: 4,
            timeFormat: 'h:mma',
            displayEventTime: true,
            showNonCurrentDates: false,
            fixedWeekCount: false,
            firstDay: 1,
            header: {
                left: '',
                center: '',
                right: ''
            },
            allDayDefault: false,
            allDaySlot: false,
            defaultView: 'agendaWeek',
            columnFormat: 'ddd',
            slotDuration: moment.duration(1, 'hours'),
            scrollTime: moment.duration('00:00:00'),
            events: [
                {
                    title: 'Not All Day Event',
                    start: '2018-05-22',
                    end: '2018-05-24',
                    allDay: false
                },
                {
                    title: 'Long Event',
                    start: new Date(2018, 4, 23, 13),
                    end: new Date(2018, 4, 23, 14)
                },
                {
                    id: 999,
                    title: 'Repeating Event',
                    start: new Date(2018, 4, 23, 16, 0),
                    allDay: false
                }
            ]
        };
        setTimeout(() => { $('#modalScheduler').fullCalendar(this.schedulerOptions); }, 500);
    }

    hideModal() {
        if (this.form.dirty || this.somethingWasChanged()) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParkingPassesService.isPassTypeModalShow = false;
                    this.settingsParkingPassesService.passTypeInPassTypeModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParkingPassesService.isPassTypeModalShow = false;
            this.settingsParkingPassesService.passTypeInPassTypeModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    submitPassType(form: NgForm) {
        if(!this.data.name) {
            toastr.warning('Name field must not be empty');
            return;
        }

        if(this.settingsParkingPassesService.selectedItemData.type == 'general' &&
           this.data.passTypeSchedule.repeatable && this.getScheduleDaysForSending().length < 1) {
            toastr.warning('Repeatable days must be chosen');
            return;
        }

        if(this.settingsParkingPassesService.selectedItemData.type == 'general' &&
            !this.data.passTypeSchedule.repeatable &&
            (!this.data.passTypeSchedule.startDayNumber || !this.data.passTypeSchedule.endDayNumber)) {
            toastr.warning('Start and End day details must be filled');
            return;
        }

        if(this.settingsParkingPassesService.selectedItemData.type == 'general' &&
            (!this.startOnTime.hours || !this.startOnTime.minutes || !this.startOnTime.amPM ||
           !this.endOnTime.hours || !this.endOnTime.minutes || !this.endOnTime.amPM)) {
            toastr.warning('All Time details must be filled');
            return;
        }

        let dataArray: any =  [];
        let data = {
            name: this.data.name,
            passTypeSchedule: this.settingsParkingPassesService.selectedItemData.type == 'general' ?
                {
                    repeatable: this.data.passTypeSchedule.repeatable,
                    // repeatEvery: {number: null, selectValue: ''},
                    startTime: this.formatScheduleTime('start'),
                    endTime: this.formatScheduleTime('end')
                } : undefined,
            passTypeScheduleSliding: this.settingsParkingPassesService.selectedItemData.type == 'sliding' ?
                {
                    slidingPeriodCount: this.data.passTypeScheduleSliding.slidingPeriodCount,
                    slidingSequenceType: this.data.passTypeScheduleSliding.slidingSequenceType
                } : undefined,
            maxTotalPassTypeCount: this.data.maxTotalPassTypeCount,
            maxTotalPassTypeSequenceType: this.data.maxTotalPassTypeSequenceType,
            // maxOfDaysPerBooking: this.data.maxOfDaysPerBooking,
            maxTimeForAdvancedBookingCount: this.data.maxTimeForAdvancedBookingCount,
            maxTimeForAdvancedBookingSequenceType: this.data.maxTimeForAdvancedBookingSequenceType,
            requiresManagerApproval: this.data.requiresManagerApproval,
            // fee: this.data.fee,
            maxPerSuiteCount: this.data.maxPerSuiteCount,
            maxPerSuiteSequenceType: this.data.maxPerSuiteSequenceType,
            maxPerLicensePlateCount: this.data.maxPerLicensePlateCount,
            maxPerLicensePlateSequenceType: this.data.maxPerLicensePlateSequenceType,
            allowOverlimitBooking: this.data.allowOverlimitBooking,
            printSuiteOnParkingPass: this.data.printSuiteOnParkingPass,
            doNotAllowResidentsPlates: this.data.doNotAllowResidentsPlates,
            allowSelfPrintingByResidents: this.data.allowSelfPrintingByResidents,
            // feeEnabledStatus: this.data.feeEnabledStatus
        };
        if(this.settingsParkingPassesService.selectedItemData.type == 'general') {
            if (data.passTypeSchedule.repeatable)
                (<any>data.passTypeSchedule).scheduleDays = this.getScheduleDaysForSending();
            else {
                (<any>data.passTypeSchedule).startDayNumber = parseInt(this.data.passTypeSchedule.startDayNumber);
                (<any>data.passTypeSchedule).endDayNumber = parseInt(this.data.passTypeSchedule.endDayNumber);
            }
        }

        if(!this.settingsParkingPassesService.selectedItemData.passTypes.length)
            dataArray.push(data);
        else {
            if(this.isEditMode) {
                this.settingsParkingPassesService.selectedItemData.passTypes.filter((type) => {
                    if (this.data.id == type.id)
                        dataArray.push(data);
                    else {
                        const tempType = JSON.parse(JSON.stringify(type));
                        tempType.passTypeSchedule.startTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.startTime);
                        tempType.passTypeSchedule.endTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.endTime);
                        delete tempType.id;
                        dataArray.push(tempType);
                    }
                });
            } else {
                this.settingsParkingPassesService.selectedItemData.passTypes.filter((type) => {
                    const tempType = JSON.parse(JSON.stringify(type));
                    tempType.passTypeSchedule.startTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.startTime);
                    tempType.passTypeSchedule.endTime = this.settingsParkingPassesService.getTimeFromDateToString(tempType.passTypeSchedule.endTime);
                    delete tempType.id;
                    dataArray.push(tempType);
                });
                dataArray.push(data);
            }
        }

        this.disabledSubmit = true;
        const url = `${this.settingsParkingPassesService.parkingPassesData.rules.patch}${this.settingsParkingPassesService.selectedItemData.id}.json`;
        this.settingsParkingPassesService.api.patch('domainParkingPass', url, { passTypes: dataArray }).subscribe(
            () => {
                toastr.success('The Pass Type was successfully updated');
                this.settingsParkingPassesService.getData();
                this.form.reset();
                this.settingsParkingPassesService.isPassTypeModalShow = false;
                this.settingsParkingPassesService.passTypeInPassTypeModal = null;
            },
            (error) => {
                this.api.errorHandler(error);
                JSON.parse(error._body).errors.filter((err) => toastr.error(err.description));
                this.disabledSubmit = false;
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParkingPassesService.getData();
        this.form.reset();
        this.hideModal();
    }

    calculateCurrentProgressBarLength(): string {
        if(this.step == 'schedule')
            return '9%';
        else if(this.step == 'restrictions')
                return '50%';
        else if(this.step == 'limits')
                return '87%';
    }

    moveToTheNextStep(moveTo): void {
        if(this.step == 'schedule') {
            this.step = moveTo;
        }
        if(this.step == 'restrictions') {
            this.step = moveTo;
        }
        if(this.step == 'limits') {
            this.step = moveTo;
        }
    }

    getScheduleDaysForSending(): Array<any> {
        let scheduleDays = [];
        this.selectedRepeatableDays.filter((day) => {
            if(day.selected)
                scheduleDays.push({ dayNumber: day.dayNumber });
        });
        return scheduleDays;
    }

    formatScheduleTime(startOrEnd): string {
        let hoursInt = parseInt(this[startOrEnd + 'OnTime'].hours == '12' && this[startOrEnd + 'OnTime'].amPM == 'AM' ? 0 : this[startOrEnd + 'OnTime'].hours);

        if(this[startOrEnd + 'OnTime'].hours != '12' && this[startOrEnd + 'OnTime'].amPM == 'PM')
            hoursInt += 12;

        return hoursInt + ':' + this[startOrEnd + 'OnTime'].minutes;
    }

    getScheduleTimeSplitted(time): any {
        const dateInCurrentTimezone = new Date(new Date(time).getTime() + new Date(time).getTimezoneOffset() * 60000);
        return {
            hours: dateInCurrentTimezone.getHours() > 12 ? (dateInCurrentTimezone.getHours() - 12).toString() :
                dateInCurrentTimezone.getHours() != 0 ? (dateInCurrentTimezone.getHours()).toString() : '12',
            minutes: dateInCurrentTimezone.getMinutes() > 9 ? (dateInCurrentTimezone.getMinutes()).toString() :
                '0' + (dateInCurrentTimezone.getMinutes()).toString(),
            amPM: dateInCurrentTimezone.getHours() >= 12 ? 'PM' : 'AM'
        };
    }

    public validateValue(event) {
        return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 0;
    }

    public validateFeeValue(event) {
        return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 44 || event.charCode == 46 || event.charCode == 0;
    }

    clearSpecialField(count, sequenceType): void {
        this.data[count]        = null;
        this.data[sequenceType] = '';
    }

    somethingWasChanged(): boolean {
        let flag = false;
        const keys = Object.keys(this.data);
        const compareTo = this.settingsParkingPassesService.passTypeInPassTypeModal ? this.settingsParkingPassesService.passTypeInPassTypeModal : new SettingsParkingRuleType();

        keys.forEach(key => {
            if(this.data[key] != compareTo[key]) {
                if(key != 'id' && key != 'passTypeSchedule' && key != 'passTypeScheduleSliding')
                    flag = true;
            }
        });
        if(this.settingsParkingPassesService.selectedItemData.type == 'general') {
            if (this.data.passTypeSchedule.repeatable != (compareTo.passTypeSchedule ? compareTo.passTypeSchedule.repeatable : false))
                flag = true;
            else {
                if (this.data.passTypeSchedule.repeatable) {
                    if (!this.compareRepeatableDays())
                        flag = true;
                } else {
                    if (this.data.passTypeSchedule.startDayNumber != compareTo.passTypeSchedule.startDayNumber)
                        flag = true;
                    if (this.data.passTypeSchedule.endDayNumber != compareTo.passTypeSchedule.endDayNumber)
                        flag = true;
                }
            }
            if (!this.compareTime())
                flag = true;
        }

        return flag;
    }

    compareTime(): boolean {
        let flag = true;
        if(this.settingsParkingPassesService.passTypeInPassTypeModal) {
            const startCompare = this.getScheduleTimeSplitted(this.data.passTypeSchedule.startTime);
            const endCompare = this.getScheduleTimeSplitted(this.data.passTypeSchedule.endTime);
            if((startCompare.hours != this.startOnTime.hours) || (startCompare.minutes != this.startOnTime.minutes) ||
               (startCompare.amPM != this.startOnTime.amPM) || (endCompare.hours != this.endOnTime.hours) ||
               (endCompare.minutes != this.endOnTime.minutes) || (endCompare.amPM != this.endOnTime.amPM))
                flag = false;
        } else {
            if(this.startOnTime.hours || this.startOnTime.minutes || this.startOnTime.amPM ||
               this.endOnTime.hours || this.endOnTime.minutes || this.endOnTime.amPM)
                flag = false;
        }

        return flag;
    }

    compareRepeatableDays(): boolean {
        let flag = true;
        if(this.settingsParkingPassesService.passTypeInPassTypeModal) {
            this.settingsParkingPassesService.passTypeInPassTypeModal.passTypeSchedule.scheduleDays.forEach(originalDay => {
                this.selectedRepeatableDays.forEach((day, index) => {
                    if(day.dayNumber != originalDay.dayNumber) {
                        if(!day.selected)
                            flag = false;
                    }
                });
            });
        } else {
            this.selectedRepeatableDays.forEach(day => {
                if(day.selected)
                    flag = false;
            });
        }
        return flag;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/pass-type-modal/pass-type-modal.component.ts